<!--
 * @Author: 李鸿润
 * @Date: 2021-07-22 11:18:32
 * @LastEditTime: 2021-08-02 18:29:45
 * @LastEditors: Please set LastEditors
 * @Description: 后勤绩效考核及评价机制设计
 * @FilePath: \hpss-ui\src\views\crmedical\value\valuedeclare\logisticsAchievements.vue
-->
<template>
    <div>
        <h2>后勤绩效考核及评价机制设计</h2>
        <span>后勤管理价值(V) = 后勤经营效益(X) ⅹ 临床科室评价(Y) ⅹ 患者满意度(Z)</span><br>
        <span>经营效益X=(成本结余+创收增值);成本结余=实际成本支出-上年同期支出（考核基数）</span>
        <div style="margin-top:40px">
            <el-form :model="achievementForm" :rules="formRules" ref="formRef" label-width="80px" style="margin-top:10px"> 
           <el-row>
                <el-col :span='5'>
                <el-form-item label="临床基数" prop="clinicalEvaluationBase"> 
                     <!-- <el-input v-model="form.clinicalEvaluationBase" maxlength="10" disabled></el-input> -->
                     <el-input v-model="achievementForm.clinicalEvaluationBase" maxlength="12"></el-input>
                </el-form-item> 
            </el-col>
            <el-col :span="1"><span style="height: 32px;display: block;line-height: 32px;">%</span></el-col>
            <el-col :span='5'>
                <el-form-item label="临床阈值" width="120" prop="clinicalEvaluationThreshold">
                    <el-input v-model="achievementForm.clinicalEvaluationThreshold" maxlength="12"></el-input>
                </el-form-item> 
            </el-col>
        <el-col :span="1"><span style="height: 32px;display: block;line-height: 32px;">%</span></el-col>
            <el-col :span='5'>
                <el-form-item label="患者基数" width="120" prop="patientSatisfactionBase">
                    <el-input v-model="achievementForm.patientSatisfactionBase" maxlength="12"></el-input>
                </el-form-item>
                
            </el-col>
            <el-col :span="1"><span style="height: 32px;display: block;line-height: 32px;">%</span></el-col>
            <el-col :span='5'>
                <el-form-item label="患者阈值" width="120" prop="patientSatisfactionThreshold">
                    <el-input v-model="achievementForm.patientSatisfactionThreshold" maxlength="12"></el-input>
                </el-form-item> 
            </el-col>
            <el-col :span="1"><span style="height: 32px;display: block;line-height: 32px;">%</span></el-col>
           </el-row>
            <el-row>
                <el-col :span='5'>
                <el-form-item label="分享系数" width="120" prop='sharingCoefficient'>
                    <el-input v-model="achievementForm.sharingCoefficient" maxlength="12"></el-input>
                </el-form-item> 
            </el-col>
            <el-col :span="1"><span style="height: 32px;display: block;line-height: 32px;">%</span></el-col>
            </el-row>
        </el-form>
        </div>
        <div style="margin-top:30px">
            <VueEditor style="margin-top:20px" id="editor"  v-model="achievementForm.checkDescription" useCustomImageHandler  @image-added="handleImageAdded"></VueEditor>
        </div>
    </div>

    

</template>

<script>
import { putFile } from "@/api/crmedical/contract/add";
import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js';
import { saveAccess } from '@/api/crmedical/value/valuebudget';
export default {
  props: {
    editDetailInfo: {},
  },
  components: {
    VueEditor,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      console.log('判断结果', reg.test(value));
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('输入格式不正确'));
      }
    };
    return {
      refList: ['formRef'],
      validateFlag: false, //表单验证状态
      achievementForm: {
        clinicalEvaluationBase: '',
        clinicalEvaluationThreshold: '',
        patientSatisfactionBase: '',
        patientSatisfactionThreshold: '',
        sharingCoefficient: '',
        checkDescription: '',
      },
      formRules: {
        clinicalEvaluationBase: [
          { required: true, message: '临床基数', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        clinicalEvaluationThreshold: [
          { required: true, message: '临床阈值', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        patientSatisfactionBase: [
          { required: true, message: '患者基数', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        patientSatisfactionThreshold: [
          { required: true, message: '患者阈值', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        sharingCoefficient: [
          { required: true, message: '分享系数', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      for (const key in this.achievementForm) {
        this.achievementForm[key] = this.editDetailInfo[key];
      }
    },
    // 富文本处理图片上传问题
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      if (this.VueEditorDisabled) {
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      // 通过上传接口返回url，将url放入富文本编辑器中
      putFile(formData)
        .then((res) => {
          let url = res.data.link;
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //（保存）提交
   async submit() {
      this.refList.forEach((item) => {
        this.$refs[item].validate((valid) => {
          if (valid) {
            this.validateFlag = true;
          } else {
            this.validateFlag = false;
          }
        });
      });
      if (this.validateFlag) {
        this.achievementForm.id = this.editDetailInfo.id;
      await  saveAccess(Object.assign(this.achievementForm)).then(({ code }) => {
          if (code == 200) {
            this.$message({
              showClose: true,
              message: '数据保存成功',
              type: 'success',
            });
            this.validateFlag = true;
          } else {
            this.validateFlag = false;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: '错了哦，这是一条错误消息',
          type: 'error',
        });
      }
      return this.validateFlag;
    },
  },
};
</script>

<style scoped>

</style>
